if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener("product-info:loaded", ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        document.body.classList.remove("quick-add-modal-open");
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        this.modalContent =
          this.modalContent || this.querySelector('[id^="QuickAddInfo-"]');
        document.body.classList.add("quick-add-modal-open");
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".loading__spinner").classList.remove("hidden");

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const productElement = responseHTML.querySelector("product-info");

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              productElement.outerHTML,
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.initCustomGallery();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      initDescriptionToggle() {
        const description = this.querySelector(".product__short-description");
        if (!description) return;

        // Remove any existing toggle to avoid duplicates
        const existingToggle = this.querySelector(".qv-desc-toggle");
        if (existingToggle) existingToggle.remove();

        // Wrap inner content so we can clamp it independently
        const textWrapEl = description.querySelector(".qv-desc-text");
        const innerHTML = textWrapEl
          ? textWrapEl.innerHTML
          : description.innerHTML;
        description.innerHTML = "";

        const textWrap = document.createElement("div");
        textWrap.className = "qv-desc-text";
        textWrap.innerHTML = innerHTML;
        description.appendChild(textWrap);

        // Create the toggle button
        const toggle = document.createElement("button");
        toggle.className = "qv-desc-toggle";
        toggle.setAttribute("type", "button");
        toggle.setAttribute("aria-expanded", "false");
        toggle.style.display = "none";
        toggle.innerHTML =
          'Read more <span class="qv-desc-toggle-arrow">↓</span>';
        description.appendChild(toggle);

        // Wait for rendering to measure height
        requestAnimationFrame(() => {
          if (textWrap.scrollHeight > textWrap.clientHeight + 4) {
            toggle.style.display = "inline-flex";
          }
        });

        let expanded = false;
        toggle.addEventListener("click", () => {
          expanded = !expanded;
          if (expanded) {
            textWrap.classList.add("qv-desc-expanded");
            toggle.innerHTML =
              'Read less <span class="qv-desc-toggle-arrow">↑</span>';
            toggle.setAttribute("aria-expanded", "true");
          } else {
            textWrap.classList.remove("qv-desc-expanded");
            toggle.innerHTML =
              'Read more <span class="qv-desc-toggle-arrow">↓</span>';
            toggle.setAttribute("aria-expanded", "false");
          }
        });
      }

      initCustomGallery() {
        const slider = this.querySelector("slider-component");
        if (!slider) return;

        const slides = slider.querySelectorAll(".product__media-item");
        if (slides.length <= 1) return;

        // Clean up any existing elements to avoid duplicates on re-render
        const existingDots = this.querySelector(".quick-view-dots");
        if (existingDots) existingDots.remove();
        const existingArrows = this.querySelectorAll(".quick-view-arrow");
        existingArrows.forEach((arrow) => arrow.remove());

        const gallery = this.querySelector("media-gallery");
        if (!gallery) return;

        gallery.style.position = "relative";

        // Create navigation dots
        const dotsWrapper = document.createElement("div");
        dotsWrapper.className = "quick-view-dots";

        slides.forEach((slide, index) => {
          const dot = document.createElement("button");
          dot.className = "quick-view-dot" + (index === 0 ? " active" : "");
          dot.setAttribute("type", "button");
          dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
          dot.addEventListener("click", () => {
            const sliderList = slider.querySelector(".slider");
            if (sliderList) {
              const slideWidth = sliderList.offsetWidth;
              sliderList.scrollTo({
                left: slideWidth * index,
                behavior: "smooth",
              });
            }
          });
          dotsWrapper.appendChild(dot);
        });

        gallery.appendChild(dotsWrapper);

        // Listen to scroll to update active dot
        const sliderList = slider.querySelector(".slider");

        // Create prev/next arrows
        const prevBtn = document.createElement("button");
        prevBtn.className = "quick-view-arrow quick-view-prev";
        prevBtn.setAttribute("type", "button");
        prevBtn.innerHTML =
          '<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
        prevBtn.addEventListener("click", () => {
          if (sliderList) {
            sliderList.scrollBy({
              left: -sliderList.offsetWidth,
              behavior: "smooth",
            });
          }
        });

        const nextBtn = document.createElement("button");
        nextBtn.className = "quick-view-arrow quick-view-next";
        nextBtn.setAttribute("type", "button");
        nextBtn.innerHTML =
          '<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
        nextBtn.addEventListener("click", () => {
          if (sliderList) {
            sliderList.scrollBy({
              left: sliderList.offsetWidth,
              behavior: "smooth",
            });
          }
        });

        const forceVisible = (el) => {
          el.style.setProperty("opacity", "1", "important");
          el.style.setProperty("visibility", "visible", "important");
          el.style.setProperty("z-index", "999999", "important");
          if (el.classList.contains("quick-view-dots")) {
            el.style.setProperty("transform", "translate3d(-50%, 0, 100px)", "important");
          } else {
            el.style.setProperty("transform", "translate3d(0, -50%, 100px)", "important");
          }
        };

        const updateArrows = (index) => {
          if (index <= 0) {
            prevBtn.style.setProperty("display", "none", "important");
          } else {
            prevBtn.style.setProperty("display", "flex", "important");
            forceVisible(prevBtn);
          }

          if (index >= slides.length - 1) {
            nextBtn.style.setProperty("display", "none", "important");
          } else {
            nextBtn.style.setProperty("display", "flex", "important");
            forceVisible(nextBtn);
          }
        };

        if (sliderList) {
          sliderList.addEventListener("scroll", () => {
            const index = Math.round(
              sliderList.scrollLeft / sliderList.offsetWidth,
            );
            const dots = dotsWrapper.querySelectorAll(".quick-view-dot");
            dots.forEach((dot, idx) => {
              if (idx === index) {
                dot.classList.add("active");
              } else {
                dot.classList.remove("active");
              }
            });
            updateArrows(index);
          });
        }

        gallery.appendChild(prevBtn);
        gallery.appendChild(nextBtn);

        // Force inline visibility on arrows and dots — overrides ALL CSS
        forceVisible(prevBtn);
        forceVisible(nextBtn);
        forceVisible(dotsWrapper);
        dotsWrapper.querySelectorAll(".quick-view-dot").forEach(forceVisible);

        updateArrows(0);

        // Safety net: re-assert visibility after any delayed CSS/transitions kick in
        setTimeout(() => {
          forceVisible(dotsWrapper);
          dotsWrapper.querySelectorAll(".quick-view-dot").forEach(forceVisible);
          // Re-run updateArrows to show the correct arrow state
          if (sliderList) {
            const idx = Math.round(sliderList.scrollLeft / sliderList.offsetWidth);
            updateArrows(isNaN(idx) ? 0 : idx);
          }
        }, 500);
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith("color-") || classApplied === "gradient")
            this.modalContent.classList.add(classApplied);
        });

        // Relocate quantity input inside buttons container for WooCommerce style inline layout
        const quantityInput = productElement.querySelector(
          ".product-form__quantity",
        );
        const productFormButtons = productElement.querySelector(
          ".product-form__buttons",
        );
        if (quantityInput && productFormButtons) {
          productFormButtons.insertBefore(
            quantityInput,
            productFormButtons.firstChild,
          );
        }

        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute("data-update-url", "false");
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector(
          "pickup-availability",
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(
          oldId,
          newId,
        );
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(
              attribute.name,
              attribute.value.replace(oldId, newId),
            );
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector(
          '[id^="Slider-Gallery"]',
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector(".product");
        const desktopColumns = product?.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes),
        );
      }
    },
  );
}
